export const root = "r20d2z4";
export const rootPartner = "r4hvyrz";
export const container = "cice406";
export const divider = "dxprb02";
export const statContainer = "szjedyc";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");